<!-- 購入完了画面でのアクションボタン -->
<template>
  <div class="actions">
    <!-- チケットを確認する ボタン -->
    <ItemButton
      :label="$t('TicketStoreTicketing.BookBookingResult.buttonLabel2')"
      actionType="btn-primary"
      @clicked="paymentDone()"
    />
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TheBBRActions",
  setup() {
    const store = useStore();

    const paymentDone = () => {
      const masterBook = store.getters["ticketing/masterBook"];
      nativeHandlerService.returnNativeAppMyticketPage({
        masterbook_id: masterBook.id,
      });
    };

    return {
      paymentDone,
    };
  },
};
</script>
